/// *** System import ***///
import { Injectable, Inject } from '@angular/core';
import { Events, ToastController } from 'ionic-angular';
import { Http, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Storage } from '@ionic/storage';
import * as CryptoJS from 'crypto-js';
import 'rxjs/add/operator/map';
import { deepCopy } from 'ionic-angular/util/util';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../../app/globals';
import { EnvVariables } from '../../../app/environment-variables/environment-variables.token';
import { SessionProvider } from '../../../providers/session';
import { MarketSessionHubProvider } from '../../../providers/serverHubs/marketSession';

@Injectable()
export class Account_PortfolioStore {
  public params: any;
  private paramsKey: string;
  private defaultParams: any;
  private isPersistParams: boolean;
  public isServerPush = false;
  /// *** Data
  private portfolioStore: any;
  public activePortfolio: any = {};
  constructor(
    // *** System
    private events: Events,
    private storage: Storage,
    private http: Http,
    private toastCtrl: ToastController,
    // *** Custom
    private globals: Globals,
    @Inject(EnvVariables) private envVariables,
    private session: SessionProvider,
    private marketSessionHubProvider: MarketSessionHubProvider) {
  }

  /// *** Configurer les paramètres
  public configParams(defaultParams: any, isPersistParams: boolean) {
    this.paramsKey = '_Account_PortfolioPage.local';
    this.params = defaultParams;
    this.defaultParams = defaultParams;
    this.isPersistParams = isPersistParams;
  }

  /// *** Récupérer les paramètres de la page
  public loadParams() {
    if (this.isPersistParams) {
      return this.storage.get(this.paramsKey).then(
        (data) => {
          if (data) {
            var paramsStr: string = CryptoJS.AES.decrypt(data.toString(), this.globals.CRYPTO_KEY).toString(CryptoJS.enc.Utf8);
            this.params = JSON.parse(paramsStr);
          }
          else {
            this.params = deepCopy(this.defaultParams);
            this.persistParams();
          }
        },
        (error) => {
          this.params = deepCopy(this.defaultParams);
          this.globals.showStorageError(this.toastCtrl, error);
        });
    }
    else {
      return new Promise<any>((resolve, reject) => { resolve() });
    }
  }

  /// *** Persister les paramètres de la page
  public persistParams() {
    if (this.isPersistParams) {
      var dataCrypt: string = CryptoJS.AES.encrypt(JSON.stringify(this.params), this.globals.CRYPTO_KEY).toString();
      return this.storage.set(this.paramsKey, dataCrypt).then(
        (succeed) => { },
        (error) => {
          this.globals.showStorageError(this.toastCtrl, error);
        });
    }
  }

  /// *** Charger le portfeuille du compte
  public load(isRefresh: boolean = false) {
    return new Promise((resolve, reject) => {
      if (isRefresh)
        this.reset();
      let portfolio = null;
      let requestHeaders = new Headers();
      requestHeaders.append('Content-Type', 'application/json');
      let requestParams = new URLSearchParams();
      requestParams.append('CustomerID', this.params.account.CustomerID);
      requestParams.append('AccountID', this.params.account.AccountID);
      requestParams.append('ContactID', this.session.data.contactID ? this.session.data.contactID : '0');
      requestParams.append('BalanceDate', new Date(this.params.balanceDate).toISOString());
      let options = new RequestOptions({ headers: requestHeaders, params: requestParams });
      this.http.get(this.envVariables.account_accountBalance_url, options).map(res => res.json()).subscribe(
        (data) => {
          portfolio = deepCopy(data);
          this.http.get(this.envVariables.account_accountInstrumentPortfolio_url, options).map(res => res.json()).subscribe(
            (data) => {
              portfolio.instruments = deepCopy(data);
              this._calc(portfolio);
              // Finalize
              this.portfolioStore = deepCopy(portfolio);
              this.activePortfolio = deepCopy(portfolio);
              this.sort();
              if (this.globals.isToday(this.params.balanceDate))
                this._eventsSub();
              resolve();
            },
            (error) => {
              this.globals.showCommunicationError(this.toastCtrl, error);
              reject();
            });
        },
        (error) => {
          this.globals.showCommunicationError(this.toastCtrl, error);
          reject();
        });
    });
  }

  // *** Recherche dans la liste des instruments
  public search(ev) {
    this.activePortfolio.instruments = deepCopy(this.portfolioStore.instruments);
    if (ev) {
      var filter: string = ev.target.value;
      if (filter && filter.trim() != '') {
        this.activePortfolio.instruments = this.activePortfolio.instruments.filter((item) => {
          let title = item.Symbol + ' ' + item.Name;
          let filters = filter.split(' ');
          for (let _filter of filters) {
            if (!(title.toLowerCase().indexOf(_filter.toLowerCase()) > -1))
              return false;
          }
          return true;
        });
      }
    }
    this.sort();
  }

  // *** Trier les instruments
  public sort() {
    // Sort By Name
    if ((this.params.sortField == 'name') && !this.params.isDescSort) {
      this.activePortfolio.instruments = this.activePortfolio.instruments.sort(function (item1, item2) {
        if (item1.Symbol < item2.Symbol)
          return -1;
        else if (item1.Symbol > item2.Symbol)
          return 1;
        else
          return 0;
      });
    }
    if ((this.params.sortField == 'name') && this.params.isDescSort) {
      this.activePortfolio.instruments = this.activePortfolio.instruments.sort(function (item1, item2) {
        if (item1.Symbol < item2.Symbol)
          return 1;
        else if (item1.Symbol > item2.Symbol)
          return -1;
        else
          return 0;
      });
    }
    // Sort By StockValue
    if ((this.params.sortField == 'stockValue') && !this.params.isDescSort) {
      this.activePortfolio.instruments = this.activePortfolio.instruments.sort(function (item1, item2) {
        if (item1.StockValue < item2.StockValue)
          return -1;
        else if (item1.StockValue > item2.StockValue)
          return 1;
        else
          return 0;
      });
    }
    if ((this.params.sortField == 'stockValue') && this.params.isDescSort) {
      this.activePortfolio.instruments = this.activePortfolio.instruments.sort(function (item1, item2) {
        if (item1.StockValue < item2.StockValue)
          return 1;
        else if (item1.StockValue > item2.StockValue)
          return -1;
        else
          return 0;
      });
    }
    // Sort By ProfitLossesRate
    if ((this.params.sortField == 'profitLossesRate') && !this.params.isDescSort) {
      this.activePortfolio.instruments = this.activePortfolio.instruments.sort(function (item1, item2) {
        if (item1.ProfitLossesRate < item2.ProfitLossesRate)
          return -1;
        else if (item1.ProfitLossesRate > item2.ProfitLossesRate)
          return 1;
        else
          return 0;
      });
    }
    if ((this.params.sortField == 'profitLossesRate') && this.params.isDescSort) {
      this.activePortfolio.instruments = this.activePortfolio.instruments.sort(function (item1, item2) {
        if (item1.ProfitLossesRate < item2.ProfitLossesRate)
          return 1;
        else if (item1.ProfitLossesRate > item2.ProfitLossesRate)
          return -1;
        else
          return 0;
      });
    }
  }

  // *** Remise à zéro des informations du portefeuille
  public reset() {
    this.activePortfolio = {};
    this._eventsUnsub();
  }

  // *** S'inscrire aux évènements liés au portefeuille
  private _eventsSub() {
    try {
      this.marketSessionHubProvider.subscribe(this.session.data.userID);
      // On 'updateTrade'
      this.events.subscribe('MarketSessionHubProvider.updateTrade', (instrumentData: any) => {
        try {
          // *** Instrument
          // Active
          let activeInstrument = this.activePortfolio.instruments.find(item => item.ISINCode == instrumentData.ISINCode);
          if (activeInstrument) {
            activeInstrument.isServerPush = true;
            activeInstrument.Price = instrumentData.LastPrice;
            activeInstrument.PriceVariationSide = instrumentData.LastPriceVariationSide;
            activeInstrument.StockValue = instrumentData.LastPrice * activeInstrument.Stock;
            activeInstrument.ProfitLosses = instrumentData.LastPrice - activeInstrument.WeightedAverageCost;
            activeInstrument.ProfitLossesRate = activeInstrument.WeightedAverageCost == 0 ? 100 : (activeInstrument.ProfitLosses / activeInstrument.WeightedAverageCost) * 100;
            setTimeout(() => {
              activeInstrument.isServerPush = false;
            }, 300);
            if ((this.params.sortField == 'variation') || (this.params.sortField == 'volume'))
              this.sort();
          }
          // *** Portfolio
          this.isServerPush = true;
          this._calc(this.activePortfolio);
          setTimeout(() => {
            this.isServerPush = false;
          }, 300);
          // Store
          let instrumentStore = this.portfolioStore.instruments.find(item => item.ISINCode == instrumentData.ISINCode);
          if (instrumentStore) {
            instrumentStore.Price = instrumentData.LastPrice;
            instrumentStore.PriceVariationSide = instrumentData.LastPriceVariationSide;
            instrumentStore.StockValue = instrumentData.LastPrice * instrumentStore.Stock;
            instrumentStore.ProfitLosses = instrumentData.LastPrice - instrumentStore.WeightedAverageCost;
            instrumentStore.ProfitLossesRate = instrumentStore.WeightedAverageCost == 0 ? 100 : (instrumentStore.ProfitLosses / instrumentStore.WeightedAverageCost) * 100;
            // Store
            this._calc(this.portfolioStore);
          }
        }
        catch (error) {
          //this.globals.showUnknownError(this.toastCtrl, error);
          this.isServerPush = false;
        }
      });
      // On 'updateInstrumentState'
      this.events.subscribe('MarketSessionHubProvider.updateInstrumentState', (instrumentData: any) => {
        try {
          // Active
          let activeInstrument = this.activePortfolio.instruments.find(item => item.ISINCode == instrumentData.ISINCode);
          if (activeInstrument) {
            activeInstrument.isServerPush = true;
            // *** ToDo
            setTimeout(() => {
              activeInstrument.isServerPush = false;
            }, 300);
            if ((this.params.sortField == 'variation') || (this.params.sortField == 'volume'))
              this.sort();
          }
          // Store
          let instrumentStore = this.portfolioStore.Instruments.find(item => item.ISINCode == instrumentData.ISINCode);
          if (instrumentStore) {
            // *** ToDo
          }
        }
        catch (error) {
          //this.globals.showUnknownError(this.toastCtrl, error);
        }
      });
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** S'inscrire aux évènements liés au portefeuille
  private _eventsUnsub() {
    try {
      this.events.unsubscribe('MarketSessionHubProvider.updateTrade');
      this.events.unsubscribe('MarketSessionHubProvider.updateInstrumentState');
      this.events.publish('MarketSessionHubProvider.abord');
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  private _calc(portfolio: any) {
    portfolio.InstrumentBalance = portfolio.instruments
      .map(item => item.StockValue ? item.StockValue : 0)
      .reduce((sum, current) => { return sum + current });
    portfolio.GlobalBalance = portfolio.InstrumentBalance + portfolio.Balance;
    let globalCumulativeCost = portfolio.instruments
      .map(item => item.CumulativeCost ? item.CumulativeCost : 0)
      .reduce((sum, current) => { return sum + current });
    portfolio.InstrumentProfitLossesRate = globalCumulativeCost == 0 ? 100 : ((portfolio.InstrumentBalance - globalCumulativeCost) / globalCumulativeCost) * 100;
  }
}


// WEBPACK FOOTER //
// ./src/pages/account/portfolio/portfolio.store.ts